import { render, staticRenderFns } from "./ListOwner.vue?vue&type=template&id=6f9e2406"
import script from "./ListOwner.vue?vue&type=script&lang=js"
export * from "./ListOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports